import qs from 'qs'
import { loadConfig } from './config/config'
import { getCurrentTime } from './util/video'
import { hasOwn, isFunction, linq } from './util/util'
import { getUA } from './util/ua'
import { getBg } from './api'
import { isHidden } from './util/page'
import { parseUrl } from './util/url'
import cookie from './util/cookie'
import { App, OS, PullTask } from './enum'
import { envTable } from './env-table'
import { cleanUrl } from './white-list'

export default class Bridge {
  constructor () {
    this.params = this.parse(window.location.search)
    this.ua = getUA()
    this.detectENV()
    const success = this.loadEnvTable()
    if (success) {
      this.render()
      this.setSchemaInfo()
      this.runTask()
    }
  }

  parse (url) {
    return parseUrl(url)
  }

  detectENV () {
    const global = this.detectGlobal()
    this.env = {
      global,
      os: this.detectOS(),
      app: this.detectAppENV()
    }
    this.config = loadConfig(global)
  }

  detectOS () {
    if (this.ua.isIOS) {
      return OS.ios
    } else {
      return OS.android
    }
  }

  detectGlobal () {
    const locale = cookie.getCookie('WWW_LOCALE')
    if (locale) {
      const lowerLocale = locale.toLowerCase()
      if (lowerLocale === 'cn') {
        return false
      }
      return lowerLocale !== 'zz'
    }
    return false
  }

  detectAppENV () {
    const ua = this.ua
    if (ua.isWeixin) {
      return App.weixin
    } else if (ua.isMobileQQ) {
      return App.qq
    } else if (ua.isWeibo) {
      return App.weibo
    }
    return App.normal
  }

  loadEnvTable () {
    const envConfig = envTable.find(curTaskConfig => {
      return ['os', 'app', 'global'].every(envKey => {
        if (hasOwn(curTaskConfig, envKey)) {
          return this.env[envKey] === curTaskConfig[envKey]
        }
        return true
      })
    })
    if (envConfig) {
      this.envConfig = envConfig
      return true
    } else {
      console.warn('mismatch task config from table')
      const envStr = JSON.stringify(this.env)
      console.info(`current env is ${envStr}`)
      const ua = navigator.userAgent
      console.info(`current ua is ${ua}`)
    }
  }

  setSchemaInfo () {
    const keyMap = {
      videoId: 'vid',
      cxid: () => {
        return this.config.CXID
      },
      clipId: 'cid',
      plId: 'plid',
      from: () => {
        return this.config.from
      },
      start_time (params) {
        if (!params.time) {
          return getCurrentTime()
        }
        return params.time
      },
      url (params) {
        if (params.url) {
          return decodeURIComponent(params.url)
        }
      },
      // subjectid: 'sid',
      vclassId: 'vclassId',
      schema: 'schema',
      autoSchema: 'autoSchema'
      // uid: 'uid'
    }
    const schemaInfo = linq(this.params, keyMap)
    schemaInfo.callt = Date.now()
    this.schemaInfo = schemaInfo
  }

  runTask = () => {
    if (this.envConfig) {
      const pullTask = this.envConfig.pull
      const tasks = this.normalizePullTask(pullTask)
      tasks.forEach(({ task, defer, hidden = true }) => {
        const runner = () => {
          if (hidden && isHidden()) {
            return false
          }
          if (isFunction(this[task])) {
            this[task]()
          } else {
            console.warn(`task: ${task} is not a bridge task`)
          }
        }
        if (defer) {
          setTimeout(() => {
            runner()
          }, defer)
        } else {
          runner()
        }
      })
    }
  }

  normalizePullTask (pullTask) {
    let tasks = []
    if (hasOwn(PullTask, pullTask)) {
      tasks = [
        {
          task: pullTask,
          hidden: false
        }
      ]
    } else if (Array.isArray(pullTask)) {
      tasks = pullTask
    }
    return tasks
  }

  // tasks start
  [PullTask.noop] () {}

  [PullTask.pullTencent] () {
    const schemaUrl = this.getSchemaUrl()
    const encodeSchemaUrl = encodeURIComponent(schemaUrl)
    const schemaKey = this.ua.isIOS ? 'ios_schema' : 'android_schema'
    const tencentUrl = `${this.config.tencentDlUrl}&${schemaKey}=${encodeSchemaUrl}`
    this.link(tencentUrl)
  }

  [PullTask.pullSchema] () {
    const schemaUrl = this.getSchemaUrl()
    this.link(schemaUrl, false)
  }

  [PullTask.appStore] () {
    let appUrl = this.config.appleDlUrl
    if (this.ua.isPad) {
      appUrl = this.config.ipadAppDlUrl
    }
    location.href = appUrl
  }

  [PullTask.downloadAPK] () {
    location.href = this.config.androidDownloadUrl
  }

  // tasks end

  link (url, frame) {
    if (!frame || this.ua.isAndroid) {
      location.href = url
    } else {
      this.frame(url)
    }
  }

  frame (url) {
    let iframe = document.getElementById('open_app_iframe')
    if (!iframe) {
      iframe = document.createElement('iframe')
      iframe.setAttribute('id', 'open_app_iframe')
      iframe.setAttribute('width', '0px')
      iframe.setAttribute('height', '0px')
      iframe.style.display = 'none'
      document.body.appendChild(iframe)
    }
    iframe.setAttribute('src', url)
  }

  getSchemaUrl () {
    const protocol = this.config.SCHEMA
    if (this.schemaInfo.schema) {
      return this.schemaInfo.schema
    } else if (this.schemaInfo.autoSchema) {
      return  `${protocol}://${this.schemaInfo.autoSchema}`
    } else {
      let prefix
      if (this.schemaInfo.url) {
        this.schemaInfo.url = cleanUrl(this.schemaInfo.url)
        if (this.ua.isAndroid) {
          prefix = 'payment'
        } else {
          prefix = 'webview'
        }
      } else if (this.schemaInfo.vclassId) {
        prefix = 'channel'
      } else if (this.schemaInfo.subjectid) {
        prefix = 'subjectpage'
      } else if (this.schemaInfo.videoId) {
        prefix = 'player'
      } else {
        prefix = 'home'
      }
      const paramStr = this.stringifySchema()
      const url = `${protocol}://${prefix}?${paramStr}`
      console.info(url)
      return url
    }
  }

  stringifySchema () {
    return qs.stringify(this.schemaInfo)
  }

  render () {
    if (this.envConfig.bg) {
      const bgBox = document.getElementById('bgbox')
      const appbtn = document.getElementById('appbtn')
      //  显示打开app按钮
      if (this.hasDownloadBtn()) {
        appbtn.style.display = 'block'
        this.bindBtnDownload()
      }
      const bgIndex = this.params.bgi || 0
      // 设置背景图
      getBg(bgIndex).then(url => {
        bgBox.style.backgroundImage = `url('${url}')`
        bgBox.style.display = 'block'
      })
    }
  }

  hasDownloadBtn () {
    const type = this.params.type
    if (type) {
      return parseInt(type) === 2
    }
    return this.envConfig.button
  }

  bindBtnDownload () {
    const $appbtn = document.getElementById('appbtn')
    if ($appbtn) {
      $appbtn.addEventListener('click', this.runTask)
    }
  }
}
